import { useEffect, useState } from "react";
import { components } from "react-select";
import { useNavigate } from "react-router-dom";
import { useCookies } from "react-cookie";
import { toast } from "react-toastify";
import http from "../../common/http-common";
import * as Comp from "../../common/CommonComponents";
import * as common from "../../common/common";
import { GetPagePermissionFn } from "../../common/authority";
import CssClass from "../../Styles/common.module.css";
import TicketSummaryTable from "../../components/Dashboard/TicketSummary/TicketSummaryTable";
import search from "../../assets/search-icon.png";
import exportIcon from "../../assets/export-icon.png";

const PAGE_NAME = "TicketSummary.js_";
const MODULE_ID = "WEB_DASH_001";

const TicketSummary = (props) => {
  document.title = common.c_TITLE + " - Ticket Summary";

  const navigate = useNavigate();
  const [cookies] = useCookies([]);
  const [userId] = useState(cookies.USER_ID);

  const [dataToBeSelect, setDataToBeSelect] = useState({
    System: [],
  });

  const [allData, setAllData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("Loading...");
  const [reload, setReload] = useState(false);

  const [companyData, setCompanyData] = useState([]);
  const [companyFieldDisabled, setCompanyFieldDisabled] = useState(false);
  const [company, setCompany] = useState([]);
  const [systemData, setSystemData] = useState([]);
  const [system, setSystem] = useState([]);
  const [selectedCompany, setSelectedCompany] = useState([]);
  const [selectedSystem, setSelectedSystem] = useState([]);
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;

  const [actionAuthority, setActionAuthority] = useState({
    READ: "N",
    WRITE: "N",
  });

  useEffect(() => {
    let promise = GetPagePermissionFn(userId, MODULE_ID);
    promise.then(
      (result) => {
        setActionAuthority(result);
        if (result.READ === "N") {
          navigate("/Home");
        }
      },
      (error) => {
        setActionAuthority({
          READ: "N",
          WRITE: "N",
        });
        common.c_LogWebError(PAGE_NAME, "GetPagePermissionFn", error);
        toast.error(error);
        navigate("/Home");
      }
    );
  }, [userId, navigate]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";

      try {
        functionName = "useEffect Get Ticket Summary";
        onLoadingHandler(true, "Getting Ticket Summary, please wait...");

        setAllData([]);

        const listItems = [];
        const companySelected = Array.isArray(company)
          ? company.map(r => r.key)
          : company?.key ? [company.key] : [];
        const systemSelected =
          system !== undefined && Object.keys(system).length !== 0
          ? system.map((r) => r.key)
          : "";

        var newStartDate = "";
        var newEndDate = "";
            
        if (startDate === null && endDate === null) {
          setDateRange([null, null])
        } else if (startDate !== null && endDate === null) {
          newStartDate = common.c_Dis_DateTime(startDate).val;
          newEndDate = "";
        } else {
          newStartDate = common.c_Dis_DateTime(startDate).val;
          newEndDate = common.c_Dis_DateTime(endDate).val;
        }

        http
          .get(
            "api/ticketsummary/GetAllTicketSummary?_startDate=" +
                newStartDate +
                "&_endDate=" +
                newEndDate +
                "&_org=" +
                companySelected +
                "&_system=" +
                systemSelected +
                "&_user=" +
                userId, { timeout: 10000000 }
          )
          .then((response) => {
            if (response.data.length > 0) {
              const groupedData = {};

              response.data.forEach((ticket) => {
                const systemName = ticket.SYSTEM_MST_NAME;
                const status = ticket.TICKET_STATUS_TYPE_NAME;
                const mandays = parseFloat(ticket.TARGET_MANDAYS) || 0;

                if (!groupedData[systemName]) {
                  groupedData[systemName] = {
                    SYSTEM_MST_NAME: systemName,
                    OPEN: 0,
                    ACKNOWLEDGE: 0,
                    RESOLVED: 0,
                    VERIFIED: 0,
                    CLOSED: 0,
                    CANCEL: 0,
                    TOTAL_TICKETS: 0,
                    TARGET_MANDAYS: 0,
                  };
                }

                if (groupedData[systemName][status] !== undefined) {
                  groupedData[systemName][status]++;
                }

                groupedData[systemName].TOTAL_TICKETS++;
                groupedData[systemName].TARGET_MANDAYS += mandays;
              });

              const listItems = Object.values(groupedData);
              setAllData(listItems);
              console.log(listItems);
            }
          })
          .catch((err) => {
            toast.error("Error on getting ticket summary. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting ticket summary. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, userId]);

  useEffect(() => {
      if (actionAuthority.READ === "Y") {
        let functionName = "";
  
        setCompanyData([]);
        setCompanyFieldDisabled(false);
        const listItems = [];

        try {
          functionName = "useEffect Get Company List";
          onLoadingHandler(true, "Getting Company List, please wait...");

          http
            .get("api/ticketsummary/GetCompanyList?_user=" + userId, { timeout: 10000 })
            .then((response) => {
              if (response.data.length > 0) {
                  response.data.forEach((data, counter) => {
                      listItems.push({
                          key: data.ORG_ID,
                          value: data.ORG_ID,
                          label: data.ORG_NAME,
                      });
                  });
                  setCompanyData(listItems);

                  if (response.data[0].ORG_CATEGORY_NAME === "CUSTOMER") {
                      setCompanyFieldDisabled(true);
                      setCompany(listItems);
                      setSelectedCompany(listItems);
                  }
              }
            })
            .catch((err) => {
              toast.error("Error on getting company list. Please try again.");
              common.c_LogWebError(PAGE_NAME, functionName, err);
            })
            .finally(() => {
              onLoadingHandler(false, "Loading...");
            });
        } catch (err) {
          toast.error("Error on getting company list. Please try again.");
          common.c_LogWebError(PAGE_NAME, functionName, err);
        }
      }
    }, [actionAuthority, userId]);

  useEffect(() => {
    if (actionAuthority.READ === "Y") {
      let functionName = "";
      
      setSystemData([]);
      const listItems = [];
      const companySelected = selectedCompany.map(company => company.value);

      try {
        functionName = "useEffect Get System List";
        onLoadingHandler(true, "Getting System List, please wait...");

        http
          .get("api/ticketsummary/GetSystemList?_user=" + userId + "&_orgId=" + companySelected, { timeout: 10000 })
          .then((response) => {
            if (response.data.length > 0) {
              response.data.forEach((data, counter) => {
                  listItems.push({
                      key: data.SYSTEM_MST_ID,
                      value: data.SYSTEM_MST_ID,
                      label: data.SYSTEM_MST_NAME,
                  });
              });
            setSystemData(listItems);
          }
          })
          .catch((err) => {
            toast.error("Error on getting system list. Please try again.");
            common.c_LogWebError(PAGE_NAME, functionName, err);
          })
          .finally(() => {
            onLoadingHandler(false, "Loading...");
          });
      } catch (err) {
        toast.error("Error on getting system list. Please try again.");
        common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  }, [reload, actionAuthority, selectedCompany, userId]);

  //#region Export Excel
  // const onExcelHandler = () => {
  //   const systemSelected =
  //   system !== undefined && Object.keys(system).length !== 0
  //       ? system.map((r) => r.key)
  //       : "";

  //   window.open(
  //     // common.c_getApiUrl() +
  //     //   "api/users/ExportExcel?_userId=" +
  //     //   userIdSelected +
  //     //   "&_role=" +
  //     //   roletypeSelected +
  //     //   "&_user=" +
  //     //   userId
  //     common.c_getApiUrl() +
  //       "api/users/ExportExcel?system=" +
  //       systemSelected
  //   );
  // };
  //#endregion

  //#region Event Handlers
  const onReloadHandler = () => {
    setReload(!reload);
  };

  const onLoadingHandler = (load, text) => {
    setLoading(load);
    setLoadingText(text);
  };

  const selectCompanyHandler = (val) => {
      let functionName = "";
      try {
          functionName = selectCompanyHandler.name;
    
          setCompany(val)
          setSelectedCompany(val)
          setSelectedSystem([]);
    
      } catch (err) {
          common.c_LogWebError(PAGE_NAME, functionName, err);
      }
    }
  //#endregion

  return (
    <>
      <Comp.Header>Ticket Summary</Comp.Header>

      <Comp.SearchPanel onSubmit={onReloadHandler}>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Company</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
                id="COMPANY"
                options={companyData}
                closeMenuOnSelect={true}
                isClearable={!companyFieldDisabled}
                isDisabled={companyFieldDisabled}
                value={companyFieldDisabled ? (selectedCompany[0] ?? null) : selectedCompany}
                hideSelectedOptions={false}
                onChange={selectCompanyHandler}
                isMulti={!companyFieldDisabled}
            />
          </td>
          <td style={{ verticalAlign: "middle", width: "10%" }}>System</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.Select
                id="SYSTEM"
                options={systemData}
                closeMenuOnSelect={true}
                isClearable={true}
                hideSelectedOptions={false}
                value={system}
                onChange={setSystem}
                isMulti
            />
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "middle", width: "10%" }}>Ticket Created Date</td>
          <td style={{ verticalAlign: "middle", width: "5%" }}>:</td>
          <td style={{ verticalAlign: "middle", width: "35%" }}>
            <Comp.DateTimePicker
                selectsRange
                onChange={(dates) => setDateRange(dates)}
                startDate={startDate}
                endDate={endDate}
            />
          </td>
        </tr>
      </Comp.SearchPanel>
      <div className={CssClass.btnWrapper}>
        <Comp.Button id="btnSearch" type="general" onClick={onReloadHandler}>
          SEARCH  <img src={search} alt="Search" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button>
        {/* <Comp.Button id="btnExcel" type="excel" onClick={onExcelHandler}>
          EXPORT  <img src={exportIcon} alt="Export" style={{ width: "16px", height: "16px", marginBottom: "3px" }} />
        </Comp.Button> */}
      </div>
      <div className={`${CssClass.card} ${CssClass.tableCard}`}>
        <div style={{ width: "100%" }}>
          <TicketSummaryTable
            page={PAGE_NAME}
            module={MODULE_ID}
            dataToBeSelect={dataToBeSelect}
            data={allData}
            onReload={onReloadHandler}
            onLoading={onLoadingHandler}
            actionAuthority={actionAuthority}
          />
        </div>
      </div>
      {loading && <Comp.Loading>{loadingText}</Comp.Loading>}
      <Comp.AlertPopup />
    </>
  );
};

export default TicketSummary;
